// extracted by mini-css-extract-plugin
export default {"sessionOverview":"parliament-index_sessionOverview__GZIyD","groupLinks":"parliament-index_groupLinks__Kd5Ui","documentLinks":"parliament-index_documentLinks__CVpa2"};